/*
* 展示年月日， 但返回的值 包含  年月日 时分秒 （）   例子： 系统右上角业务日期 头像旁边那个
*
* */

import React, { Component } from "react";
import DatePickerClientS from "../DatePickerTimeZoneConversion";
require("./index.less");

// 发生订单的实时时间 包括时分秒
export default class DatePickClientHourTime extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        //let Format = ['YYYY-MM-DD','YYYYMMDD','YYYY.MM.DD','YYYY/MM/DD'];
        let {
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            ...other
        } = this.props;

        return (
            <DatePickerClientS
                {...other}
                needTime={true}
                needNowTime={true}
                format={format}
                MultiTZ={true}
                className={`DatePickClientHourTime ${this.props.className}`}
            />
        );
    }
}

DatePickClientHourTime.defaultProps = {
    showClear: true,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};
